import { Component, OnInit } from '@angular/core';
import { ReturnObject } from '../../../../model/returnobject';
import { SysadminServiceService } from '../../../../shared/sysadmin-service.service';
import { StatusMessagesService } from '../../../../shared/statusmessage.service';
import { InternalMsgService } from '../../../../shared/internal.msg.service';

@Component({
    selector: 'sysadmin-give-dispensation',
    templateUrl: './sysadmin-give-dispensation.component.html',
    styleUrls: ['./sysadmin-give-dispensation.component.scss']
})
export class SysadminGiveDispensationComponent implements OnInit {
    assignmentNumber = "";
    assignmentNumbersWithDispensation: string[] = [];

    constructor(private sysadminService: SysadminServiceService,
        private statusMessagesService: StatusMessagesService,
        private msgService: InternalMsgService) {
    }

    ngOnInit(): void {
      this.getAssignmentNumbersWithDispensation();
    }

    isDataNotSet(): boolean {
        return ((this.assignmentNumber.trim() === '')
            || (!this.assignmentNumber)
        );
    }

    removeDispensation(assignmentNumber: string) {
        this.sysadminService.removeDispensation(assignmentNumber)
            .subscribe((msg: ReturnObject<string>) => {
                if (msg.isFailure) {
                    this.statusMessagesService.showToasterError('Error', msg.failureMessage);
                    return;
                }
                this.getAssignmentNumbersWithDispensation();
                this.statusMessagesService.showToasterInfo('Removed', msg.value);
            })
    }

    giveDispensation() {
        this.sysadminService.giveDispensation(this.assignmentNumber)
            .subscribe((msg: ReturnObject<string>) => {
                if (msg.isFailure) {
                    this.statusMessagesService.showToasterError('Error', msg.failureMessage);
                    return;
                }
                this.getAssignmentNumbersWithDispensation();
                this.statusMessagesService.showToasterInfo('Save', msg.value);
            })
    }

    getAssignmentNumbersWithDispensation() {
      this.msgService.ontoggleSpinnerSet(true);
        this.sysadminService.getAssignmentNumbersWithDispensation()
            .subscribe((assignmentNumbers: ReturnObject<string[]>) => {
                if (assignmentNumbers.isFailure) {
                    this.statusMessagesService.showToasterError('Error', assignmentNumbers.failureMessage);
                    return;
                }
                this.msgService.ontoggleSpinnerSet(false);
                this.assignmentNumbersWithDispensation = assignmentNumbers.value;
            });
    }

}